export const UnderEighteensValidatorKey = 'underEighteens';
export const InArrayValidatorKey = 'inArray';
export const PasswordValidatorKey = 'password';
export const PhoneValidatorKey = 'phone';
export const DuplicatedValueValidatorKey = 'duplicatedValue';
export const MinDateValidatorKey = 'minDate';
export const MaxDateValidatorKey = 'maxDate';
export const FileTypeValidatorKey = 'fileType';
export const FileSizeValidatorKey = 'fileSize';
export const OnlyLatinValidatorKey = 'onlyLatin';
export const WhitespaceValidatorKey = 'whitespace';
export const IbanValidatorKey = 'iban';
export const LatinDigitsValidatorKey = 'latinDigits';
export const OnlyCyrillicValidatorKey = 'onlyCyrillic';
export const OnlyDigitsValidatorKey = 'onlyDigits';
export const EmailExistsValidatorKey = 'emailExists';
export const BlackListedCountryValidatorKey = 'blackListedCountry';
export const SwiftValidatorKey = 'swift';
export const SortCodeValidatorKey = 'sortCode';
export const OtpInvalidLengthKey = 'otpInvalidLength';
export const OtpInvalidSymbolKey = 'otpInvalidSymbol';
export const InvalidAmountKey = 'invalidAmount';
export const ArrayEveryValidatorKey = 'arrayEvery';
export const NotNullArrayValuesValidatorKey = 'notNullArrayValuesValidator';
export const AddressValidatorKey = 'AddressValidatorKey';
export const ConfirmPasswordValidatorKey = 'ConfirmPasswordValidatorKey';
export const TaxNumberValidatorKey = 'TaxNumberValidatorKey';
export const AutocompleteStringValidatorKey = 'InvalidAutocompleteString';
export const LatinLettersAndSymbolsValidatorKey = 'onlyLatinAndSpecialSymbols';
export const CompanyNameValidatorKey = 'companyName';
export const LatinDigitsFullStopValidatorKey = 'latinDigitsFullStopValidatorKey';
export const LatinLettersAndSpecialSymbolsAndWhiteSpaceValidatorKey = 'LatinLettersAndSpecialSymbolsAndWhiteSpaceValidator';
export const AmountMaxValidatorKey = 'AmountMaxValidatorKey';
export const AmountMinValidatorKey = 'AmountMinValidatorKey';
export const NameValidatorKey = 'NameValidatorKey';
